import {ActionBuilder} from "co-redux-builders";

export default ActionBuilder.build({
    clearReducer: () => ({}),
    dispatchAddAlertToQueue: (alertId: string) => (alertId),
    dispatchSetDeleteDocument: (documentId: string) => (documentId)
});